<div *ngIf="actionType === 'edit'; else createTitle">
	<app-entity-mat-dialog-title title="Edit Gift Certificate"></app-entity-mat-dialog-title>
</div>
<ng-template #createTitle>
	<app-entity-mat-dialog-title title="Gift Certificate Issuance"></app-entity-mat-dialog-title>
</ng-template>

<div mat-dialog-content>
  <!-- The step transition animation is disabled: inside this dialog its
       Web Animations players are created but never start, so the active step
       lands translated a full width offscreen and never paints (the Review
       step showed blank). Disabling it applies each step's state directly.
       The slide adds nothing in a modal anyway. -->
  <mat-stepper linear #stepper [@.disabled]="true" (selectionChange)="onStepChange($event)">
    <mat-step [stepControl]="giftCertificateForm" [editable]="!paymentSubmitted">
      <form [formGroup]="giftCertificateForm">
        <ng-template matStepLabel>Gift Certificate Details</ng-template>
        <div class="form-group">
          <mat-form-field>
            <input matInput formControlName="giftCertificateCode" placeholder="Gift Certificate Code" readonly="true" required>
          </mat-form-field>

          <!-- Executive Dropdown -->
          <div class="col-12">
            <mat-form-field class="full-width-field">
              <mat-label>Executive</mat-label>
              <mat-select required matInput formControlName="field_executive" name="field_executive">
                <mat-option>None</mat-option>
                <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                  <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_executive)"
                    [value]="element.uid">
                    {{ element.value }}
                    <ng-container *ngIf="element.status === '0' && element.uid === field_executive"></ng-container>
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>

					<!-- Package Autocomplete -->
					<div class="col-12">
						<mat-form-field class="full-width-field">
						<mat-label>Package</mat-label>
						<input formControlName="field_enrollment_package_name" name="field_enrollment_package_name" (input)="onAutocompletePackages($event);" matInput
								[matAutocomplete]="autoCompletePackage">
						<button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
								<mat-icon>manage_accounts</mat-icon>
						</button>
						</mat-form-field>
						<mat-autocomplete #autoCompletePackage="matAutocomplete" (optionSelected)="onPackageLookup($event);">
						<mat-option *ngFor="let option of autoCompletePackageOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
								{{option.label}} ({{option.value}})
						</mat-option>
						</mat-autocomplete>
				</div>
          <mat-form-field class="mb-3">
            <input matInput formControlName="giftCertificateAmount" placeholder="Gift Certificate Amount" readonly required>
            <mat-hint>Set by the selected package</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Expiration Date</mat-label>
            <input matInput
                   [owlDateTime]="expirationDatePicker"
                   [owlDateTimeTrigger]="expirationDatePicker"
                   formControlName="expirationDate"
                   placeholder="Select a date"
                   readonly
                   required>
            <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="expirationDatePicker">
              <mat-icon>calendar_today</mat-icon>
            </span>
            <owl-date-time #expirationDatePicker [pickerType]="'calendar'"></owl-date-time>
          </mat-form-field>
          <mat-form-field class="mb-3">
            <mat-label>Gift message</mat-label>
            <textarea matInput
                      formControlName="giftMessage"
                      rows="2"
                      placeholder="Happy birthday! Can't wait to see you dance."></textarea>
            <mat-hint>From the purchaser to the recipient. Printed on the certificate and in its email.</mat-hint>
          </mat-form-field>
          <mat-form-field class="mb-3">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="giftCertificateNotes" rows="2"></textarea>
            <mat-hint>For staff only. The recipient never sees these.</mat-hint>
          </mat-form-field>

          <div class="row">
            <mat-label>Purchaser<sup>*</sup></mat-label>
          </div>
          <mat-button-toggle-group formControlName="checkoutType" (change)="onCheckoutTypeChange($event)" aria-label="Checkout Type">
            <mat-button-toggle value="guest">No student account</mat-button-toggle>
            <mat-button-toggle value="existing">Link an existing account</mat-button-toggle>
          </mat-button-toggle-group>

          <!-- The account picker fills the purchaser fields, so it comes first. -->
          <div class="mt-2" *ngIf="giftCertificateForm.value.checkoutType === 'existing'">
            <mat-form-field class="full-width-field">
              <mat-label>Student account</mat-label>
              <input name="giftCertificatePurchaser" (input)="onAutocompletePurchaser($event)" matInput formControlName="giftCertificatePurchaser" required #giftCertificatePurchaserInput [matAutocomplete]="autoCompletePurchaser">
              <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                <mat-icon>manage_accounts</mat-icon>
              </button>
              <mat-hint>Search by name. The purchaser details below are filled from the account and can be adjusted.</mat-hint>
            </mat-form-field>
            <mat-autocomplete #autoCompletePurchaser="matAutocomplete">
              <mat-option (onSelectionChange)="lookupStudentAccount($event, true);" *ngFor="let option of autoCompletePurchaserOptions" [value]="option.label + ' (' + option.value + ')'">
                {{option.label}} ({{option.value}})
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="mt-2">
            <mat-form-field>
              <input matInput formControlName="purchaserName" placeholder="Purchaser's Name" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput formControlName="purchaserEmail" placeholder="Purchaser's Email" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput formControlName="purchaserPhone" placeholder="Purchaser's Phone" required>
            </mat-form-field>
          </div>

          <mat-form-field>
						<input matInput formControlName="field_recipient_name" placeholder="Recipient's Name" required>
					</mat-form-field>
          <mat-form-field>
            <input matInput formControlName="recipientEmail" placeholder="Recipient's Email" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput formControlName="recipientPhone" placeholder="Recipient's Phone" required>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Email the certificate on</mat-label>
            <input matInput
                   [owlDateTime]="emailSendDatePicker"
                   [owlDateTimeTrigger]="emailSendDatePicker"
                   formControlName="emailSendDate"
                   placeholder="Leave blank to send it yourself"
                   readonly>
            <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="emailSendDatePicker">
              <mat-icon>calendar_today</mat-icon>
            </span>
            <owl-date-time #emailSendDatePicker [pickerType]="'calendar'"></owl-date-time>
            <mat-hint>Optional: for a surprise, pick the day it should arrive</mat-hint>
          </mat-form-field>
        </div>
      </form>
    </mat-step>

		<mat-step [stepControl]="paymentForm" [editable]="!paymentSubmitted">
			<form [formGroup]="paymentForm">
				<ng-template matStepLabel>Payment Information</ng-template>
				<div class="form-group">
					<mat-radio-group class="row" name="field_payment_type" formControlName="field_payment_type" aria-label="Select an option">
						<ng-container *ngFor="let element of this.taxonomyService.payment_type">
							<div class="col-4">
								<mat-radio-button [value]="element.id">{{ element.name }}</mat-radio-button>
							</div>
						</ng-container>
					</mat-radio-group>

					<ng-container *ngIf="paymentForm.get('field_payment_type').value === 'Stripe'">
						<!-- Credit card fields -->
						<mat-form-field>
							<mat-label>Credit Card Number</mat-label>
							<input matInput formControlName="cc_number" required>
						</mat-form-field>

						<mat-form-field>
							<mat-label>Expiration Date</mat-label>
							<input matInput formControlName="cc_expiration" required>
						</mat-form-field>

						<mat-form-field>
							<mat-label>CVV</mat-label>
							<input matInput formControlName="cc_cvv" required>
						</mat-form-field>
					</ng-container>

				</div>
			</form>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel>Review and Confirmation</ng-template>
			<div class="container">
				<div class="row">
					<div class="col-md-6">
						<section class="gift-certificate-details">
							<h3>Gift Certificate Details</h3>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Gift Certificate Code:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.giftCertificateCode}}</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Gift Certificate Amount:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.giftCertificateAmount | studioCurrency }}</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Expiration Date:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.expirationDate | date}}</div>
							</div>
							<div class="row mb-3" *ngIf="giftCertificateForm.value.giftMessage">
								<div class="col-sm-4"><strong>Gift Message:</strong></div>
								<div class="col-sm-8 gift-message-preview">{{giftCertificateForm.value.giftMessage}}</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Notes (staff only):</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.giftCertificateNotes}}</div>
							</div>
						</section>
					</div>
					<div class="col-md-6">
						<section class="purchaser-information">
							<h3>Purchaser Information</h3>
								<div class="row mb-3">
									<div class="col-sm-4"><strong>Purchaser's Name:</strong></div>
									<div class="col-sm-8">{{giftCertificateForm.value.purchaserName}}</div>
								</div>
								<div class="row mb-3">
									<div class="col-sm-4"><strong>Purchaser's Email:</strong></div>
									<div class="col-sm-8">{{giftCertificateForm.value.purchaserEmail}}</div>
								</div>
								<div class="row mb-3">
									<div class="col-sm-4"><strong>Purchaser's Phone:</strong></div>
									<div class="col-sm-8">{{giftCertificateForm.value.purchaserPhone}}</div>
								</div>
						</section>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<section class="recipient-information">
							<h3>Recipient Information</h3>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Recipient's Name:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.field_recipient_name}}</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Recipient's Email:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.recipientEmail}}</div>
							</div>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Recipient's Phone:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.recipientPhone}}</div>
							</div>
							<div class="row mb-3" *ngIf="giftCertificateForm.value.emailSendDate">
								<div class="col-sm-4"><strong>Email on:</strong></div>
								<div class="col-sm-8">{{giftCertificateForm.value.emailSendDate | date}}</div>
							</div>
						</section>
					</div>
					<div class="col-md-6">
						<section class="payment-information">
							<h3>Payment Information</h3>
							<div class="row mb-3">
								<div class="col-sm-4"><strong>Payment Type:</strong></div>
								<div class="col-sm-8">{{getPaymentTypeName(paymentForm.value.field_payment_type)}}</div>
							</div>
						</section>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<section class="total-amount text-center">
							<h3>Total Amount</h3>
							<p class="lead">{{giftCertificateForm.value.giftCertificateAmount | studioCurrency }}</p>
						</section>
					</div>
				</div>
			</div>
		</mat-step>
  </mat-stepper>
</div>

<mat-dialog-actions align="end">
  <!-- Close sits left as the accent action on every step; the step-specific
       primary action is right-most, matching the rest of the system. -->
  <button mat-raised-button color="accent" type="button"
          (click)="DialogRef.close()">{{ currentStep === 2 ? 'Close' : 'Cancel' }}</button>

  <button *ngIf="currentStep === 1 && !paymentSubmitted" mat-raised-button color="accent"
          type="button" (click)="stepper.previous()">Back</button>

  <button *ngIf="currentStep === 0" mat-raised-button color="primary" type="button"
          [disabled]="!isGiftCertificateFormValid()"
          (click)="stepper.next()">Next</button>

  <button *ngIf="currentStep === 1" mat-raised-button color="primary" type="button"
          [disabled]="!paymentForm.valid || paymentSubmitted"
          (click)="onSubmit()">Run Payment</button>

  <button *ngIf="currentStep === 2" mat-raised-button color="primary" type="button"
          [disabled]="!giftCertificateID"
          (click)="sendGiftCertificateEmail(giftCertificateID)">
    <mat-icon>email</mat-icon>
    {{ giftCertificateForm.value.emailSendDate ? 'Send Email Now Instead' : 'Send Gift Certificate Email' }}
  </button>

  <button *ngIf="currentStep === 2" mat-raised-button color="primary" type="button"
          [disabled]="!giftCertificateID"
          (click)="sendGiftCertificateSms(giftCertificateID)">
    <mat-icon>sms</mat-icon>
    Send Text Message
  </button>
</mat-dialog-actions>
